export const GameStyleCategoryTags = {
  ArbitrageBetting: {
    color: '#FFC745',
    name: 'Arbitrage Betting'
  },
  Arbitrage_Betting: {
    color: '#FFC745',
    name: 'Arbitrage Betting'
  },
  'Arbitrage Betting': {
    color: '#FFC745',
    name: 'Arbitrage Betting'
  },
  'Arbitrage Betting 1': {
    color: '#FFC745',
    name: 'Arbitrage Betting 1'
  },
  'Arbitrage Betting 2': {
    color: '#FFC745',
    name: 'Arbitrage Betting 2'
  },
  'Arbitrage Betting 3': {
    color: '#FFC745',
    name: 'Arbitrage Betting 3'
  },
  'Bot-Assisted Arbitrage ': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage '
  },
  'Bot_Arb': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage '
  },
  'Suspicious Fixed Matches': {
    color: '#00C6D7',
    name: 'Suspicious Fixed Matches'
  },
  'SFF 1': {
    color: '#00C6D7',
    name: 'Suspicious Fixed Matches 1'
  },
  'Suspicious Fixed Matches 1': {
    color: '#00C6D7',
    name: 'Suspicious Fixed Matches 1'
  },
  'SFM 2': {
    color: '#00C6D7',
    name: 'Suspicious Fixed Matches 2'
  },
  'Suspicious Fixed Matches 2': {
    color: '#00C6D7',
    name: 'Suspicious Fixed Matches 2'
  },
  'SFM 3': {
    color: '#00C6D7',
    name: 'Suspicious Fixed Matches 3'
  },
  'Suspicious Fixed Matches 3': {
    color: '#00C6D7',
    name: 'Suspicious Fixed Matches 3'
  },
  'Corridor': {
    color: '#FF4F90',
    name: 'Corridor Betting'
  },
  'Corridor 1': {
    color: '#FF4F90',
    name: 'Corridor Betting 1'
  },
  'Corridor 2': {
    color: '#FF4F90',
    name: 'Corridor Betting 2'
  },
  'Corridor 3': {
    color: '#FF4F90',
    name: 'Corridor Betting 3'
  },
  'Corridor Betting': {
    color: '#FF4F90',
    name: 'Corridor Betting'
  },
  'Corridor Betting 1': {
    color: '#FF4F90',
    name: 'Corridor Betting 1'
  },
  'Corridor Betting 2': {
    color: '#FF4F90',
    name: 'Corridor Betting 2'
  },
  'Corridor Betting 3': {
    color: '#FF4F90',
    name: 'Corridor Betting 3'
  },
  LateBetting: {
    color: '#FF8317',
    name: 'Late Betting'
  },
  Late_Betting: {
    color: '#FF8317',
    name: 'Late Betting'
  },
  'Late Betting 1': {
    color: '#FF8317',
    name: 'Late Betting 1'
  },
  'Late Betting 2': {
    color: '#FF8317',
    name: 'Late Betting 2'
  },
  'Late Betting 3': {
    color: '#FF8317',
    name: 'Late Betting 3'
  },
  StrongOpinion: {
    color: '#00A967',
    name: 'Strong Opinion'
  },
  Strong_Opinion: {
    color: '#00A967',
    name: 'Strong Opinion'
  },
  'Strong Opinion': {
    color: '#00A967',
    name: 'Strong Opinion'
  },
  'Strong Opinion 1': {
    color: '#00A967',
    name: 'Strong Opinion 1'
  },
  'Strong Opinion 2': {
    color: '#00A967',
    name: 'Strong Opinion 2'
  },
  'Strong Opinion 3': {
    color: '#00A967',
    name: 'Strong Opinion 3'
  },
  BotArb: {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage '
  },
  'Bot Arbitrage': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage '
  },
  'Bot Arb': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage '
  },
  'Bot Arb 1': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage 1'
  },
  'Bot Arb 2': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage 2'
  },
  'Bot Arb 3': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage 3'
  },
  'Bot-Assisted Arbitrage': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage'
  },
  'Bot-Assisted Arbitrage 1': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage 1'
  },
  'Bot-Assisted Arbitrage 2': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage 2'
  },
  'Bot-Assisted Arbitrage 3': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage 3'
  },
  Bonus_Hunter: {
    color: '#36B7FD',
    name: 'Bonus Hunter'
  },
  'Bonus Hunter': {
    color: '#36B7FD',
    name: 'Bonus Hunter'
  },
  'Bonus Hunter 1': {
    color: '#36B7FD',
    name: 'Bonus Hunter 1'
  },
  'Bonus Hunter 2': {
    color: '#36B7FD',
    name: 'Bonus Hunter 2'
  },
  'Bonus Hunter 3': {
    color: '#36B7FD',
    name: 'Bonus Hunter 3'
  },
  'Value Betting': {
    color: '#B26CAA',
    name: 'Value Betting'
  }
};

export const AssessmentsTags = {
  'Not a threat': {
    color: '#1EA66C',
    name: 'Not a Threat'
  },
  'Under investigation': {
    color: '#F48A3A',
    name: 'Under investigation'
  },
  'OPP betting': {
    color: '#FFCA5F',
    name: 'OPP betting'
  },
  'SOPP betting': {
    color: '#D9B916',
    name: 'SOPP betting'
  },
  'Advantage play': {
    color: '#EF5D8F',
    name: 'Advantage'
  },
  'Bonus abuse': {
    color: '#5FB4F6',
    name: 'Bonus abuse'
  },
  'Tournament abuse': {
    color: '#B763C6',
    name: 'Tournament abuse'
  },
  'Wonging': {
    color: '#CD1D59',
    name: 'Wonging'
  },
  'Card Counting': {
    color: '#7481C9',
    name: 'Card Counting'
  },
  'Advanced Card Counting': {
    color: '#ABBB36',
    name: 'Advanced Card Counting'
  },
  'System issues': {
    color: '#737373',
    name: 'System issues'
  },
  'Fraudulent activity': {
    color: '#E64E48',
    name: 'Fraudulent activity'
  },
  'Suspicious tips': {
    color: '#B10F78',
    name: 'Suspicious tips'
  },
  'Robot Play': {
    color: '#1473E6',
    name: 'Robot Play'
  },
  'Roulette Bias Advantage Player': {
    color: '#3BB940',
    name: 'Roulette Bias Advantage Player'
  },
  'Side Bet Counter': {
    color: '#5C3796',
    name: 'Side Bet Counter'
  }
};

export const AdditionalCategoryTags = {
  Female: {
    color: '#ef5d8f',
    name: 'Female'
  },
  Age: {
    color: '#47b4a9',
    name: 'Age'
  },
  Country: {
    color: '#5fb4f6',
    name: 'Country'
  },
  City: {
    color: '#006699',
    name: 'City'
  },
  Custom: {
    color: '#b763c6',
    name: 'Custom'
  },
  Currency: {
    color: '#76a145',
    name: 'Currency'
  },
  'Dangerous IP': {
    color: '#cd1d59',
    name: 'Dangerous IPs'
  },
  'Predefined IP': {
    color: '#5c3796',
    name: 'Predefined IPs'
  },
  'Women': {
    color: '#5c3796',
    name: 'Women'
  },
  Additional: {
    color: '#b763c6',
    name: 'Additional'
  },
  'High Risk': {
    color: '#7124ec',
    name: 'High Risk'
  },
  HighRisk: {
    color: '#7124ec',
    name: 'High Risk'
  },
  'Not Playing': {
    color: '#662177',
    name: 'Not Playing'
  },
  NotPlaying: {
    color: '#662177',
    name: 'Not Playing'
  },
  'No Bonus User': {
    color: '#cf64ea',
    name: 'No Bonus User'
  },
  NoBonusUser: {
    color: '#cf64ea',
    name: 'No Bonus User'
  },
  Casino: {
    color: '#cf64ea',
    name: 'Casino'
  },
  Agent: {
    color: '#cf64ea',
    name: 'Agent'
  },
  'Test User': {
    color: '#d91984',
    name: 'Test User'
  },
  TestUser: {
    color: '#d91984',
    name: 'Test User'
  },
  '1/2SFM': {
    color: '#730341',
    name: '1/2SFM'
  },
  Half_SFM: {
    color: '#730341',
    name: '1/2SFM'
  },
  Strong: {
    color: '#730341',
    name: 'Strong'
  },
  'Before VIP': {
    color: '#8d1a26',
    name: 'Before VIP'
  },
  BeforeVIP: {
    color: '#8d1a26',
    name: 'Before VIP'
  },
  Review: {
    color: '#8d1a26',
    name: 'Review'
  },
  'Value Bet': {
    color: '#e5838e',
    name: 'Value Bet'
  },
  ValueBet: {
    color: '#e5838e',
    name: 'Value Bet'
  },
  VeryNegative: {
    color: '#e5838e',
    name: 'Very Negative'
  },
  'BetShop Agent': {
    color: '#50191f',
    name: 'BetShop Agent'
  },
  BetShopAgent: {
    color: '#50191f',
    name: 'BetShop Agent'
  },
  Fingerprint: {
    name: 'Fingerprint',
    color: '#7481c8'
  },
  107: {
    name: 'Fingerprint',
    color: '#7481c8'
  },
  AffilateIdBTag: {
    color: '#f7776e',
    name: 'Affiliate/BTag'
  },
  'Affiliate/BTag': {
    color: '#f7776e',
    name: 'Affiliate/BTag'
  },
  'AffiliateId/BTag': {
    color: '#f7776e',
    name: 'Affiliate/BTag'
  },
  108: {
    color: '#f7776e',
    name: 'Affiliate/BTag'
  }
};

export const FinancialCategoryTags = {
  'New User': {
    color: '#47cfe0',
    name: 'New User'
  },
  New_User: {
    color: '#47cfe0',
    name: 'New User'
  },
  'Neutral': {
    color: '#f48a3a',
    name: 'Neutral'
  },
  'Positive': {
    color: '#46904a',
    name: 'Positive'
  },
  'Negative': {
    color: '#e03f33',
    name: 'Negative'
  },
  'Very Negative': {
    color: '#bb1414',
    name: 'Very Negative'
  },
  Very_Negative: {
    color: '#bb1414',
    name: 'Very Negative'
  },
  'VIP': {
    color: '#822691',
    name: 'VIP'
  },
  'VIP Bronze': {
    color: '#822691',
    name: 'VIP Bronze'
  },
  'VIP Silver': {
    color: '#0091ce',
    name: 'VIP Silver'
  },
  'VIP Gold': {
    color: '#207ede',
    name: 'VIP Gold'
  },
  'VIP Platinum': {
    color: '#007e74',
    name: 'VIP Platinum'
  },
  'Late Betting': {
    color: '#FF8317',
    name: 'Late Betting'
  },
  'Age': {
    color: '#47b4a9',
    name: 'Age'
  },
  'Arbitrage Betting': {
    color: '#FFC745',
    name: 'Arbitrage Betting'
  },
  'Suspicious Fixed Matches': {
    color: '#00C6D7',
    name: 'Suspicious Fixed Matches'
  },
  SFM: {
    color: '#00C6D7',
    name: 'Suspicious Fixed Matches'
  },
  'Corridor Betting': {
    color: '#FF4F90',
    name: 'Corridor Betting'
  },
  'Strong Opinion': {
    color: '#00A967',
    name: 'Strong Opinion'
  },
  'Bot Arb': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage '
  },
  'Bonus Hunter': {
    color: '#36B7FD',
    name: 'Bonus Hunter'
  },
  'Country': {
    color: '#5fb4f6',
    name: 'Country'
  },
  'Currency': {
    color: '#76a145',
    name: 'Currency'
  },
  'Dangerous IP': {
    color: '#cd1d59',
    name: 'Dangerous IP'
  },
  'Custom': {
    color: '#b763c6',
    name: 'Custom'
  },
  'Women': {
    color: '#ef5d8f',
    name: 'Women'
  }
};

export const FinancialTPCategoryTags = {
  'TP New User': {
    color: '#47cfe0',
    name: 'TP New User'
  },
  'TP Neutral': {
    color: '#3D3D5F',
    name: 'TP Neutral'
  },
  'TP Positive': {
    color: '#46904a',
    name: 'TP Positive'
  },
  'TP Negative': {
    color: '#e03f33',
    name: 'TP Negative'
  },
  'TP Very Negative': {
    color: '#bb1414',
    name: 'TP Very Negative'
  },
  'TP VIP': {
    color: '#822691',
    name: 'TP VIP'
  },
  'TP VIP Bronze': {
    color: '#822691',
    name: 'TP VIP Bronze'
  },
  'TP VIP Silver': {
    color: '#0091ce',
    name: 'TP VIP Silver'
  },
  'TP VIP Gold': {
    color: '#207ede',
    name: 'TP VIP Gold'
  },
  'TP VIP Platinum': {
    color: '#007e74',
    name: 'TP VIP Platinum'
  },
  'TP Late Betting': {
    color: '#FF8317',
    name: 'TP Late Betting'
  },
  'TP Age': {
    color: '#47b4a9',
    name: 'TP Age'
  },
  'TP Arbitrage Betting': {
    color: '#FFC745',
    name: 'TP Arbitrage Betting'
  },
  'TP SFM': {
    color: '#00C6D7',
    name: 'TP Suspicious Fixed Matches'
  },
  'TP Suspicious Fixed Matches': {
    color: '#00C6D7',
    name: 'TP Suspicious Fixed Matches'
  },
  'TP Corridor': {
    color: '#FF4F90',
    name: 'TP Corridor Betting'
  },
  'TP Corridor Betting': {
    color: '#FF4F90',
    name: 'TP Corridor Betting'
  },
  'TP Strong Opinion': {
    color: '#00A967',
    name: 'TP Strong Opinion'
  },
  'TP Bot Arb': {
    color: '#1473E6',
    name: 'TP Bot-Assisted Arbitrage'
  },
  'TP Bot-Assisted Arbitrage': {
    color: '#1473E6',
    name: 'TP Bot-Assisted Arbitrage'
  },
  'TP Bonus Hunter': {
    color: '#36B7FD',
    name: 'TP Bonus Hunter'
  },
  'TP Country': {
    color: '#5fb4f6',
    name: 'TP Country'
  },
  'TP Currency': {
    color: '#76a145',
    name: 'TP Currency'
  },
  'TP Dangerous IP': {
    color: '#cd1d59',
    name: 'TP Dangerous IP'
  },
  'TP Custom': {
    color: '#b763c6',
    name: 'TP Custom'
  },
  'TP Women': {
    color: '#ef5d8f',
    name: 'TP Women'
  },
  'TP Additional': {
    color: '#b763c6',
    name: 'TP Additional'
  },
  'TP Value Betting': {
    color: '#B26CAA',
    name: 'TP Value Betting'
  }
};

export const AmlAdditionalRiskCategoryTags = {
  None: {
    color: '',
    name: 'None'
  },
  Low: {
    color: '#abbb36',
    name: 'Low'
  },
  Medium: {
    color: '#f48a3a',
    name: 'Medium'
  },
  High: {
    color: '#f7776e',
    name: 'High'
  },
  VeryHigh: {
    color: '#e03f33',
    name: 'Very High'
  },
  'Very High': {
    color: '#e03f33',
    name: 'Very High'
  }
};

export const PlayerStatuses = {
  1: {
    color: '#ef5d8f',
    name: 'Temporary'
  },
  Temporary: {
    color: '#ef5d8f',
    name: 'Temporary'
  },
  2: {
    color: '#5fb4f6',
    name: 'Permanent'
  },
  Permanent: {
    color: '#5fb4f6',
    name: 'Permanent'
  },
  3: {
    color: '#f7776e',
    name: 'Deactivated'
  },
  Deactivated: {
    color: '#f7776e',
    name: 'Deactivated'
  },
  4: {
    color: '#abbb36',
    name: 'Closed'
  },
  Closed: {
    color: '#abbb36',
    name: 'Closed'
  },
  5: {
    color: '#cd1d59',
    name: 'Forbidden'
  },
  Forbidden: {
    color: '#cd1d59',
    name: 'Forbidden'
  },
  6: {
    color: '#e03f33',
    name: 'Blocked'
  },
  Blocked: {
    color: '#e03f33',
    name: 'Blocked'
  },
  7: {
    color: '#20b2aa',
    name: 'Open'
  },
  Open: {
    color: '#20b2aa',
    name: 'Open'
  },
  8: {
    color: '#8fbc8b',
    name: 'Suspended'
  },
  Suspended: {
    color: '#8fbc8b',
    name: 'Suspended'
  },
  9: {
    color: '#4682b4',
    name: 'Dormant'
  },
  Dormant: {
    color: '#4682b4',
    name: 'Dormant'
  }
};

export const Type = {
  1: {
    color: '#822691',
    name: 'Single'
  },
  2: {
    color: '#46904A',
    name: 'Express'
  },
  'Accepted': {
    color: '#46904A',
    name: 'Accepted'
  },
  'Cash Out': {
    color: '#822691',
    name: 'Cash Out'
  },
  'Lost': {
    color: '#cd1d59',
    name: 'Lost'
  },
  'New': {
    color: '#4682b4',
    name: 'New'
  },
  'Rejected': {
    color: '#b26c72',
    name: 'Rejected'
  },
  'Returned': {
    color: '#20b2aa',
    name: 'Returned'
  },
  'Won': {
    color: '#7481c8',
    name: 'Won'
  },
  'Pending Detail': {
    color: '#213cd5',
    name: 'Pending Detail'
  },
  'Waiting Partner': {
    color: '#58c212',
    name: 'Waiting Partner'
  },
  'Rollbacked': {
    color: '#5411a6',
    name: 'Rollbacked'
  }
};

export const OppositeType = {
  'Opposite': {
    color: '#F1A100',
    name: 'Opposite'
  },
  'Self Opposite': {
    color: '#F48A3A',
    name: 'Self Opposite'
  },
  Mixed: {
    color: '#FA8072',
    name: 'Mixed'
  }
};

export const ProductsType = {
  'SRMT': {
    color: '#FFA45F',
    name: 'SRMT'
  },
  'LCRMT': {
    color: '#77A31B',
    name: 'LCRMT'
  },
  'AML & RG': {
    color: '#3BBCBC',
    name: 'AML & RG'
  },
  'CRMT': {
    color: '#207ede',
    name: 'CRMT'
  }
};

export const crmtGS = {
  'New User': {
    color: '#B763C6',
    name: 'New User'
  },
  'Neutral': {
    color: '#3D3D5F',
    name: 'Neutral'
  },
  'VIP': {
    color: '#F48A3A',
    name: 'VIP'
  },
  'Bonus Hunter': {
    color: '#36B7FD',
    name: 'Bonus Hunter'
  },
  'N/A': {
      color: '#5FB4F6',
      name: 'N/A'
},
  'Cheaters': {
    color: '#C90002',
    name: 'Cheaters'
  },
  'Money Transfusion': {
    color: '#A7BD00',
    name: 'Money Transfusion'
  },
  'Monitoring': {
    color: '#FF8317',
    name: 'Monitoring'
  },
  'Team Play': {
    color: '#863FE5',
    name: 'Team Play'
  },
  'Advantage Play': {
    color: '#FF4F90',
    name: 'Advantage'
  },
  'Advantage': {
    color: '#FF4F90',
    name: 'Advantage'
  },
  'Tournament Abuse': {
    color: '#00A967',
    name: 'Tournament Abuse'
  },
  'Robot Play': {
    color: '#1473E6',
    name: 'Robot Play'
  },
  'Bot-Assisted Arbitrage': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage'
  },
  'Opposite Betting': {
    color: '#FFC745',
    name: 'Opposite Betting'
  },
  'Not Typical Activity': {
    color: '#00C6D7',
    name: 'Not Typical Activity'
  }
};

export const sportCategory = {
  'Arbitrage Betting': {
    color: '#FFC745',
    name: 'Arbitrage Betting'
  },
  'Bot-Assisted Arbitrage': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage'
  },
  'Corridor Betting': {
    color: '#FF4F90',
    name: 'Corridor Betting'
  },
  'Late Betting': {
    color: '#FF8317',
    name: 'Late Betting'
  },
  'Suspicious Fixed Matches': {
    color: '#00C6D7',
    name: 'Suspicious Fixed Matches'
  },
  'Strong Opinion': {
    color: '#00A967',
    name: 'Strong Opinion'
  },
  'Bonus Hunter': {
    color: '#36B7FD',
    name: 'Bonus Hunter'
  },
  'Value Betting': {
    color: '#B26CAA',
    name: 'Value Betting'
  }
};

export const casinoCategory = {
  'Monitoring': {
    color: '#FF8317',
    name: 'Monitoring'
  },
  'Bonus Hunter': {
    color: '#36B7FD',
    name: 'Bonus Hunter'
  },
  'Bot': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage'
  },
  'Bot-Assisted Arbitrage': {
    color: '#1473E6',
    name: 'Bot-Assisted Arbitrage'
  },
  'Advantage Play': {
    color: '#FF4F90',
    name: 'Advantage'
  },
  'Advantage': {
    color: '#FF4F90',
    name: 'Advantage'
  },
  'Opposite Betting': {
    color: '#FFC745',
    name: 'Opposite Betting'
  },
  'Tournament Abuse': {
    color: '#00A967',
    name: 'Tournament Abuse'
  },
  'Money Transfusion': {
    name: 'Money Transfusion',
    color: '#A7BD00'
  },
  'Not Typical Activity': {
    color: '#00C6D7',
    name: 'Not Typical Activity'
  },
  'Team Play': {
    name: 'Team Play',
    color: '#863FE5'
  },
  'VIP': {
      color: '#F48A3A',
      name: 'VIP'
  }
};

export const paymentCategory = {
  'Provider / Deposit Abuse': {
    color: '#9747FF',
    name: 'Provider / Deposit Abuse'
  },
  'FinFraud Technical Abuse': {
    color: '#094E9A',
    name: 'FinFraud Technical Abuse'
  },
  'Potential Carding': {
    color: '#880000',
    name: 'Potential Carding'
  },
  'Approved Carding': {
    color: '#006940',
    name: 'Approved Carding'
  },
  'Chargeback Fraud': {
    color: '#C8032E',
    name: 'Chargeback Fraud'
  },
  'Potential Money Laundering': {
    color: '#739E10',
    name: 'Potential Money Laundering'
  }
};

export const additionalCategory = {
  'Chip Dumping': {
    color: '#FF8747',
    name: 'Chip Dumping'
  },
  'Soft-BOT': {
    color: '#1473E6',
    name: 'Soft-BOT'
  },
  'Multi account': {
    color: '#9747FF',
    name: 'Multi account'
  }
};

export const trafficCategory = {
  'CPA Abuse': {
    color: '#419BFF',
    name: 'CPA Abuse'
  },
  'Revenue Fraud': {
    color: '#2D38FF',
    name: 'Revenue Fraud'
  },
  'Non-Profitable Traffic': {
    color: '#7E2DFF',
    name: 'Non-Profitable Traffic'
  },
  'Non-Retained Players / Monitoring': {
    color: '#D52DFF',
    name: 'Non-Retained Players / Monitoring'
  },
  'BOT Traffic': {
    color: '#FF2D7E',
    name: 'BOT Traffic'
  },
  'Gnoming': {
    color: '#FF8F2D',
    name: 'Gnoming'
  }
};